import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getCampaign} from '../../../apis/campaign/getCampaign'

const useQueryCampaign = (id: string) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.campaign.getCampaign(),
        queryFn: async () => {
            const {data, pageInfo} = await getCampaign(id)
            return {data, pageInfo}
        },
        refetchOnWindowFocus: false,
    })

    return {data, refetch}
}

export default useQueryCampaign
